"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTextBig = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
require("./input-text-big.css");
/**
 * @deprecated need refactoring! questo componente dovrebbe usare InputField qui ci sono cose duplicate
 */
var InputTextBig = /** @class */ (function (_super) {
    __extends(InputTextBig, _super);
    function InputTextBig(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange$ = new rxjs_1.Subject();
        _this.subscription = null;
        _this.onChange = function (e) {
            var currentValue = _this.blockNotAllowedCharacters(e.target.value);
            _this.setState({ currentValue: currentValue });
            _this.onChange$.next(_this.sanitizeValue(currentValue));
        };
        _this.state = {
            currentValue: _this.formatValue(_this.props.value),
        };
        return _this;
    }
    InputTextBig.prototype.buildPrefix = function () {
        var _this = this;
        var wrapper = function (c) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "input-text-big-input-prefix ".concat(_this.props.disabled ? 'disabled' : '') }, { children: c }))); };
        switch (this.props.type) {
            case 'money':
                return wrapper('€');
        }
    };
    InputTextBig.prototype.componentDidMount = function () {
        var _this = this;
        this.subscription = this.onChange$
            .pipe((0, operators_1.debounceTime)(this.props.debounceTime || 400))
            .subscribe(function (debounced) { return _this.props.onChange && _this.props.onChange(debounced); });
    };
    InputTextBig.prototype.componentWillUnmount = function () {
        (0, function_1.pipe)(O.fromNullable(this.subscription), O.map(function (subscription) { return subscription.unsubscribe(); }), O.toUndefined);
    };
    InputTextBig.prototype.componentDidUpdate = function (prevProp) {
        if (prevProp.value !== this.props.value && this.props.value !== this.sanitizeValue(this.state.currentValue)) {
            this.setState({ currentValue: this.formatValue(this.props.value) });
        }
    };
    InputTextBig.prototype.blockNotAllowedCharacters = function (value) {
        switch (this.props.type) {
            case 'money': {
                var found_1 = false;
                return value.replace(/[^0-9]/g, function (c) {
                    if (!found_1 && (c === ',' || c === '.')) {
                        found_1 = true;
                        return c;
                    }
                    return '';
                });
            }
        }
    };
    InputTextBig.prototype.sanitizeValue = function (value) {
        switch (this.props.type) {
            case 'money': {
                var nValue = value.replace(/[^0-9,.]/g, '').replace(/,/g, '.');
                if ('' === nValue) {
                    return 0;
                }
                return parseFloat(nValue);
            }
        }
    };
    InputTextBig.prototype.formatValue = function (value) {
        switch (this.props.type) {
            case 'money':
                if ('' === value) {
                    return 0;
                }
                return (Math.round(parseFloat(value) * 100) / 100).toString().replace(/\./g, ',');
        }
    };
    InputTextBig.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "input-text-big" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "input-text-big-suggestion" }, { children: this.props.suggestion })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "input-text-big-content ".concat(this.props.disabled ? 'disabled' : 'icon_edit_dark') }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "input-text-big-label" }, { children: this.props.label })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "input-text-big-input" }, { children: [this.buildPrefix(), (0, jsx_runtime_1.jsx)("input", { type: "text", value: this.state.currentValue, onChange: this.onChange, disabled: this.props.disabled })] }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "input-text-big-footer" }, { children: this.props.footer }))] })));
    };
    return InputTextBig;
}(React.PureComponent));
exports.InputTextBig = InputTextBig;
//# sourceMappingURL=InputTextBig.js.map